import Vue from "vue";
import { find, filter, union, shuffle } from 'lodash';
var ScrollMagic = require('ScrollMagic');
export default Vue.extend({
    name: 'ub-employees',
    data() {
        return {
            counter: 0,
            skills: {
                strategie: 'Strategie',
                design: 'Design',
                uiux: 'UI-UX',
                redaktion: 'Redaktion',
                illustration: 'Illustration',
                programmierung: 'Programmierung',
                fotografie: 'Fotografie',
                beratung: 'Beratung',
            },
            shuffledSkills: [],
            employees: [
                { name: 'Thilo Hecht', skills: ['strategie', 'fotografie', 'uiux', 'design'], location: 'mannheim' },
                { name: 'Michael Schug', skills: ['strategie', 'beratung'], location: 'mannheim' },
                { name: 'Thomas Stark', skills: ['strategie', 'uiux', 'beratung'], location: 'mannheim' },
                { name: 'Marcus Weber', skills: ['strategie', 'beratung'], location: 'mannheim' },
                /*{name: 'Tanja Gluding', skills: ['design', 'strategie'], location: 'mannheim'},
                {name: 'Julia Pillatzki', skills: ['design', 'strategie'], location: 'mannheim'},*/
                //{name: 'Benjamin Kalberlah', skills: ['beratung'], location: 'mannheim'},
                //{name: 'Nina Steinert', skills: ['beratung', 'design'], location: 'mannheim'},
                { name: 'Susanne Schwenger', skills: ['design'], location: 'mannheim' },
                //{name: 'Christof Kurz', skills: ['design'], location: 'mannheim'},
                { name: 'Marcel Weik', skills: ['design', 'illustration', 'fotografie'], location: 'mannheim' },
                { name: 'Alessandro Tarantino', skills: ['design', 'illustration'], location: 'mannheim' },
                { name: 'Kathrin Müller', skills: ['design', 'uiux'], location: 'mannheim' },
                { name: 'Juliane Zieher', skills: ['design', 'uiux'], location: 'mannheim' },
                { name: 'Klaus Marzina', skills: ['design'], location: 'mannheim' },
                { name: 'Kerstin Hirsch', skills: ['design'], location: 'mannheim' },
                { name: 'Carolin Bergmann', skills: ['design'], location: 'mannheim' },
                // {name: 'Roger Thiel', skills: ['beratung'], location: 'mannheim'},
                { name: 'Dominik Läufer', skills: ['beratung'], location: 'mannheim' },
                { name: 'Patrick Straub', skills: ['strategie', 'beratung'], location: 'mannheim' },
                // {name: 'Freerk van Zeijl', skills: ['programmierung'], location: 'mannheim'},
                // {name: 'Maximilian Wilhelm', skills: ['programmierung'], location: 'mannheim'},
                { name: 'Alexej Krzewitzki', skills: ['programmierung', 'strategie', 'beratung'], location: 'mannheim' },
                { name: 'Lale Ertopcu', skills: ['redaktion'], location: 'mannheim' },
                // {name: 'Yves Krämer', skills: ['strategie', 'beratung'], location: 'berlin'},
                { name: 'Paul Krämer', skills: ['design'], location: 'berlin' },
                { name: 'Anne Buchheister', skills: ['design', 'beratung', 'illustration'], location: 'berlin' },
                { name: 'Bastian Thomanek', skills: ['design'], location: 'berlin' },
                // {name: 'Tobias Faust', skills: ['programmierung'], location: 'berlin'},
                // {name: 'Peter Compernass', skills: ['design'], location: 'berlin'},
                { name: 'Gerald Bader', skills: ['redaktion'], location: 'berlin' },
            ],
            activeSkills: [],
            activeEmployees: []
        };
    },
    mounted() {
        /* init highlighting animation on desktop */
        if (window.innerWidth > 1024 && document.getElementsByClassName('employee-skill-area').length) {
            this.shuffledSkills = shuffle(this.skills);
            this.highlightingAnimation();
        }
    },
    methods: {
        highlightingAnimation() {
            var controller = new ScrollMagic.Controller();
            if (window.innerWidth > 1024 && document.getElementsByClassName('employee-skill-area').length) {
                const welcomeScene = new ScrollMagic.Scene({
                    triggerElement: '.employee-skill-area .row',
                    triggerHook: 0.9
                })
                    .addTo(controller)
                    .on("enter", () => {
                    let randomSkills = 3;
                    if (this.counter == 0) {
                        setTimeout(() => {
                            let skill = this.shuffledSkills[this.counter];
                            this.highlightEmployees(skill.toLowerCase().replace('-', ''));
                            this.highlightingAnimation();
                            this.counter++;
                        }, 600);
                    }
                    else if (this.counter <= 2) {
                        setTimeout(() => {
                            let skill = this.shuffledSkills[this.counter];
                            this.highlightEmployees(skill.toLowerCase().replace('-', ''));
                            this.highlightingAnimation();
                            this.counter++;
                        }, 600);
                    }
                    else {
                        setTimeout(() => {
                            this.blur();
                        }, 600);
                    }
                });
            }
        },
        highlightSkills(employee) {
            this.blur();
            this.activeSkills = union(this.activeSkills, employee.skills);
            this.activeEmployees = union(this.activeEmployees, [employee]);
        },
        highlightEmployees(key) {
            this.blur();
            this.activeSkills = union(this.activeSkills, [key]);
            this.activeEmployees = union(this.activeEmployees, this.hasSkill(key));
        },
        blur() {
            this.activeSkills = [];
            this.activeEmployees = [];
        },
        isActiveSkill(skill) {
            return this.activeSkills.indexOf(skill) !== -1;
        },
        isActiveEmployee(employee) {
            return find(this.activeEmployees, { name: employee.name });
        },
        hasSkill(skill) {
            return filter(this.employees, e => {
                return e.skills.indexOf(skill) !== -1;
            });
        }
    },
    computed: {
        locMannheim() {
            return filter(this.employees, { 'location': 'mannheim' });
        },
        locBerlin() {
            return filter(this.employees, { 'location': 'berlin' });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/components/ub-employees/ub-employees.ts
// module id = null
// module chunks = 